// Components
import { LayoutContent } from "../components/layout/_layoutConent";


export function Ontwerpvraag() {
    return (
        <LayoutContent header="Ontwerpvraag">
            <p className="md:py-2 py-6 md:text-2xl text-lg font-regular text-neutal-900">
                ‘Hoe kunnen we de foutmarges bij het meten van vochtinname door patiënten op 
                de afdeling cardiologie zo veel mogelijk minimaliseren?’
            </p>
        </LayoutContent>
    )
}
